<template>
    <div>
        <!-- QR CODE for desktops -->
        <div class="pt-2 d-flex flex-wrap">

            <div class="mt-4 mr-4" @click="redirectToAppStore()">
                <v-img :src="cdnBaseUrl('/img/apple_app_store.png')" max-width="200"/>
                <qr-code :value="componentData.apple_app_store_url" :options="{ width: 200 }"></qr-code>
            </div>

            <div class="mt-4" @click="redirectToGooglePlayStore()">
                <v-img :src="cdnBaseUrl('/img/google_play_store.png')" max-width="200"/>
                <qr-code :value="componentData.google_play_store_url" :options="{ width: 200 }"></qr-code>
            </div>
        </div>

    </div>
</template>

<script>

import QrCode from '@chenfengyuan/vue-qrcode';

export default {

    name: "MobileAppDownloadControls",

    components: {
        QrCode
    },

    props: {
        componentData: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            mobileDetect: null,
        }
    },

    methods: {

        redirectToAppStore() {
            this.sendToUrl(this.componentData.apple_app_store_url, true);
        },

        redirectToGooglePlayStore() {
            this.sendToUrl(this.componentData.google_play_store_url, true);
        }
    }
}
</script>
